import { Layers } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";
import { useT, useImg } from "@/context/ContentContext";
import { fileUrl } from "@/lib/api";

export default function HomeQualidade() {
    const { settings } = useSettings();
    const t = useT();
    const img = useImg();
    const qualityImg = img("home.qualidade.image", settings.quality_image_id
        ? fileUrl(settings.quality_image_id)
        : "https://images.unsplash.com/photo-1503387762-592deb58ef4e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200");

    return (
        <section className="py-16 sm:py-24 bg-white">
            <div className="max-w-6xl mx-auto px-6 sm:px-10 grid lg:grid-cols-2 gap-14 items-center">
                <div>
                    <div className="eyebrow mb-6"><Layers className="w-3.5 h-3.5" /> {t("home.qualidade.eyebrow", "Qualidade")}</div>
                    <h2 className="font-display text-3xl sm:text-5xl font-bold tracking-tight leading-[1.05]">
                        {t("home.qualidade.title", "O que fica atrás da parede importa tanto como aquilo que fica")} <span className="font-serif-italic text-[hsl(var(--copper))]">{t("home.qualidade.title_accent", "à vista")}</span><span className="text-[hsl(var(--copper))]">.</span>
                    </h2>
                    <p className="text-[hsl(var(--graphite))]/75 text-lg mt-6 leading-relaxed">
                        {t("home.qualidade.p1", "Parte importante da qualidade de uma remodelação fica escondida — nos suportes, nas instalações, nas impermeabilizações, na preparação de superfícies.")}
                    </p>
                    <p className="text-[hsl(var(--graphite))]/75 text-lg mt-4 leading-relaxed">
                        {t("home.qualidade.p2", "Fazer bem quando o cliente está a ver é fácil. O nosso trabalho também tem de estar bem feito quando ninguém o vai voltar a ver.")}
                    </p>
                </div>
                <div className="rounded-3xl overflow-hidden aspect-[4/3]">
                    <img src={qualityImg} alt="Detalhe técnico" className="w-full h-full object-cover" loading="lazy" />
                </div>
            </div>
        </section>
    );
}
